import type { Doc } from '@ppwr/convex/_generated/dataModel'
import type { PlayerAction } from '@ppwr/convex/shared/types'
import { isPlayerActionWithAmount } from '@ppwr/convex/shared/types'
import { translate } from '../../../i18n'

const outOfHandStates = ['waiting', 'folded', 'out'] as const

export const getLastActionTextForPlayerConvex = (
  player: Doc<'players'> | null | undefined,
  lastAction: PlayerAction | undefined
): string => {
  if (!player) return ''

  if (outOfHandStates.includes(player.state as (typeof outOfHandStates)[number])) {
    return translate(`newGameScreen.player.lastActionForPlayerConvex.${player.state}`)
  }

  let action = lastAction?.action || ''
  if (lastAction?.action === 'blind' && player.position === 'bb') {
    action = 'BIGBLIND'
  }
  if (lastAction?.action === 'blind' && player.position === 'sb') {
    action = 'SMALLBLIND'
  }

  if (!(action && lastAction?.action)) return translate('newGameScreen.player.lastActionForPlayerConvex.waiting')

  const lastActionText = translate(`newGameScreen.player.lastActionForPlayerConvex.${action}`)

  if (lastAction && !isPlayerActionWithAmount(lastAction)) {
    return lastActionText
  }

  if (!lastAction.amount) return ''

  return `${lastActionText} ${lastAction.amount > 0 ? lastAction.amount : ''}`
}
